import React from "react";
import CrudList from "@/components/CrudList";

export default function Holidays() {
  return (
    <CrudList
      title="Hari Libur"
      subtitle="Nasional, keagamaan, dan libur perusahaan (dipakai untuk hitung lembur)"
      endpoint="/holidays"
      exportModule={undefined}
      auditEntity="holidays"
      columns={[
        { key: "date", label: "Tanggal" },
        { key: "name", label: "Nama" },
        { key: "type", label: "Tipe" },
        { key: "recurring", label: "Berulang tahunan?", render: (r) => r.recurring ? "Ya" : "Tidak" },
      ]}
      fields={[
        { key: "date", label: "Tanggal", type: "date", required: true },
        { key: "name", label: "Nama Libur", required: true, wide: true, placeholder: "HUT RI / Idul Fitri / Cuti Bersama" },
        { key: "type", label: "Tipe", type: "select", options: [
          { value: "national", label: "Nasional" },
          { value: "religious", label: "Hari Raya" },
          { value: "company", label: "Perusahaan" },
        ], required: true },
      ]}
    />
  );
}
